// "8:10 AM" from a Date/ISO/epoch, in the browser's REAL local timezone.
//
// Distinct from formatTime.js: that one pins UTC on purpose because FVD's
// domain timestamps (ride/class scheduledTime) encode naive venue-local wall
// clock as "...Z" (#591/#592). This one is for actual client-side instants —
// "last updated 8:10 AM" — which really did happen in the announcer's own
// timezone, so it must use the browser's normal local-time rendering.
export function formatClockTime(value) {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}

export default formatClockTime;
